import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { authGuard } from './auth.gaurd';
import { ViewProfileComponent } from './view-profile/view-profile.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { LoginMainComponent } from './authentication/login-main/login-main.component';
import { HomeComponent } from './home/home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      { path: '', redirectTo: '/authentication/login', pathMatch: 'full' },
      { path: 'home', component: HomeComponent, canActivate: [authGuard] },
      { path: 'master', loadChildren: () => import('./master/master.routing').then(m => m.masterRoutes), canActivate: [authGuard] },
      { path: 'customer-detail', loadChildren: () => import('./customer-detail/customerdetail.routing').then(m => m.customerDetailRoutes), canActivate: [authGuard] },
      { path: 'CRF', loadChildren: () => import('./CRF/crf.routing').then(m => m.crfRoutes), canActivate: [authGuard] },
      { path: 'new-enquiry', loadChildren: () => import('./enquiry/enquiry.routing').then(m => m.enquiryRoutes), canActivate: [authGuard] },
      { path: 'sample-verification', loadChildren: () => import('./sample-verification/sampleverification.routing').then(m => m.sampleVerificationRoutes), canActivate: [authGuard] },
      { path: 'audit-trail', loadChildren: () => import('./audittrail/audittrail.routing').then(m => m.auditTrailRoutes), canActivate: [authGuard] },
       { path: 'report', loadChildren: () => import('./Report/report.routing').then(m => m.reportRoutes), canActivate: [authGuard] },
      { path: 'view-profile', component: ViewProfileComponent, canActivate: [authGuard] }
      ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication/login',
        component: LoginMainComponent
        // loadChildren: () =>
        //   import('../app/authentication/authentication.routing').then(m => m.AuthenticationRoutes)
      },
      {
        path: 'changePassword',
        loadComponent: () =>
          import('./change-password/change-password.component')
            .then(c => c.ChangePasswordComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
  
];
